import React from "react";
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  GeoAltFill,
  TelephoneFill,
  EnvelopeFill,
} from "react-bootstrap-icons";
import "./footer.scss";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer-section">

      <div className="container py-5">
        <div className="row">

          {/* COMPANY INFO */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h4 className="footer-title">Uiplus Technologies</h4>
            <p>
              We provide modern web development and enterprise software
              solutions to help businesses grow digitally.
            </p>

            {/* Social Icons */}
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" >
                <Linkedin />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" >
                <Twitter />
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-subtitle">Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/data-deletion">Data Deletion</Link></li>
            </ul>
          </div>

          {/* SERVICES */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-subtitle">Our Services</h5>
            <ul className="footer-links">
              <li><Link to="/products/school-management">School ERP</Link></li>
              <li><Link to="/products/finance-management">Finance Application</Link></li>
              <li><Link to="/products/school-management">Dynamic Website</Link></li>
              <li><Link to="/products/finance-management">Custom Application</Link></li>
              <li><Link to="/service">Services</Link></li>
            </ul>
          </div>

          {/* CONTACT + NEWSLETTER */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-subtitle">Contact Us</h5>

            <p>
              <GeoAltFill className="footer-icon" />
              Sr.no.31/2/3, Ingale Platinum, Shivane, Pune - 411023
            </p>

            <p>
             <TelephoneFill className="footer-icon" />
              <a href="tel:+918855947070" style={{color:"white"}}>+91 8855 94 7070</a> /
              <a href="tel:+919158926281" style={{color:"white"}}> 9158 92 6281</a>
            </p>

            <p>
             <EnvelopeFill className="footer-icon" />
             <a href="mailto:info@uiplus.in" style={{color:"white"}}>info@uiplus.in</a>
            </p>

             {/* Newsletter */}
            <div className="newsletter">
              <input
                type="email"
                placeholder="Enter your email"
                className="form-control"
              />
              <button className="subscribe-btn">
                Subscribe
              </button>
            </div>

          </div>

        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom text-center">
        © {new Date().getFullYear()} Uiplus Technologies. All Rights Reserved.
      </div>

    </footer>
  );
}

export default Footer;

